<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12.5247 2.5C15.2697 2.5 17.5259 4.59323 17.784 7.27057C20.435 7.55404 22.5 9.79821 22.5 12.5247C22.5 15.2528 20.4325 17.4981 17.7789 17.779C17.4981 20.4325 15.2528 22.5 12.5247 22.5C9.79821 22.5 7.55404 20.435 7.27087 17.7837C4.59323 17.5259 2.5 15.2697 2.5 12.5247C2.5 9.78128 4.59074 7.52618 7.26579 7.26582C7.52618 4.59074 9.78128 2.5 12.5247 2.5ZM12.4996 14.9098L12.486 14.9376C11.6915 16.483 10.1575 17.5857 8.35156 17.7786C8.62585 19.8379 10.3897 21.4268 12.5246 21.4268C14.6579 21.4268 16.4206 19.8404 16.6974 17.783C14.859 17.6045 13.297 16.4836 12.4996 14.9098ZM13.0435 13.0428L13.0687 13.04C14.9701 13.285 16.4742 14.7982 16.7047 16.7044C14.799 16.4734 13.2857 14.9693 13.041 13.0674L13.0435 13.0428ZM7.27111 8.34521C5.18722 8.59931 3.57422 10.3736 3.57422 12.5247C3.57422 14.6749 5.18597 16.4487 7.26725 16.7038C7.44307 14.8632 8.56472 13.2982 10.1405 12.4997C8.57885 11.709 7.46322 10.1648 7.27111 8.34521ZM11.8418 13.0608L11.9573 13.0439C11.958 13.0514 11.9588 13.0588 11.9601 13.0667C11.718 14.952 10.229 16.4471 8.3457 16.6979C8.57355 14.8421 10.0089 13.3598 11.8418 13.0608ZM17.7786 8.35107L17.7589 8.51577C17.517 10.261 16.4228 11.7338 14.9102 12.5002C16.484 13.2969 17.6048 14.859 17.784 16.6969C19.8408 16.4205 21.4272 14.6578 21.4272 12.5245C21.4272 10.3896 19.8383 8.62579 17.7786 8.35107ZM16.5328 8.36933L16.6978 8.34668C16.4466 10.2286 14.9523 11.7173 13.0673 11.9598C13.0593 11.959 13.0514 11.9582 13.043 11.9581C13.2896 10.1249 14.7159 8.66569 16.5328 8.36933ZM8.35352 8.35254L8.36896 8.46721C8.66519 10.2833 10.1233 11.7092 11.9553 11.9567C11.7036 10.0858 10.2234 8.60548 8.35352 8.35254ZM8.3457 7.27028C8.59905 5.18706 10.3737 3.57324 12.5253 3.57324C14.6756 3.57324 16.4494 5.18499 16.7049 7.26515C14.8639 7.44209 13.2989 8.56374 12.5009 10.1396C11.7096 8.57787 10.1654 7.46225 8.3457 7.27028Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgClowderLogo',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>